(function () {
    'use strict';

    angular
        .module('partners')
        .controller('ReportsTwsListController', ReportsTwsListController);

    ReportsTwsListController.$inject = ['twsList', 'ManagePartnersService', 'ExpoService', '$uibModal', '$q'];

    function ReportsTwsListController(twsList, ManagePartnersService, ExpoService, $uibModal, $q) {
        var vm = this;

        vm.twsList = twsList.data;

        /* PAGINATION */
        // vm.pageChanged = pageChanged;
        // vm.setPage = setPage;
        // vm.totalItems = twsList.data.total;
        // vm.currentPage = twsList.data.current_page;
        // vm.itemsPerPage = twsList.data.per_page;
        // vm.page = 1;


        activate();


        // function setPage(page) {
        //     vm.currentPage = page;
        // }
        //
        //
        // function pageChanged(page) {
        //     vm.page = vm.currentPage;
        //     vm.getByFilter();
        // }


        function activate() {

        }

    }
})();